export const LEVEL = {
    GRID_TAB: 'grid_tab',
    GRID_SUBTAB: 'grid_subtab',
    GRID_FILTERS: 'grid_filters'
};

export const LEVELS_ORDER = [ LEVEL.GRID_TAB, LEVEL.GRID_SUBTAB, LEVEL.GRID_FILTERS ];